import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as pendingProductsFromSomeoneElseState from '../employee-detail.reducer';
import * as pendingProductsFromSomeoneElseReducer from '../reducers/pending-products-from-someone-else.reducer';

export const getPendingProductsFromSomeoneElse = createSelector(
  pendingProductsFromSomeoneElseState.getPendingProductsFromSomeoneElseState,
  pendingProductsFromSomeoneElseReducer.getPendingProductsFromSomeoneElseResponse
);
